import { InvoiceTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1810. 請求タスク登録
 * [POST] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/invoice_tasks
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  name: string;
  description?: string;
  billing_schedule_detail_id: number;
  due_date?: string;
};

const createInvoiceTask = (props: Props): Promise<InvoiceTask> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/invoice_tasks`,
    props
  );
};

export const useCreateInvoiceTask = () => {
  return useMutation({
    mutationFn: createInvoiceTask
  });
};
